'use client';

import { useCallback } from 'react';

export const useAnnualPayments = (annualPayments, setAnnualPayments, setShowResults) => {
  const handlePaymentInputChange = useCallback((id, field, value) => {
    setShowResults(false);
    setAnnualPayments(prev => {
      return prev.map(payment =>
        payment.id === id ? { ...payment, [field]: value } : payment
      );
    });
  }, [setAnnualPayments, setShowResults]);

  const handleAddPayment = useCallback(() => {
    setShowResults(false);
    setAnnualPayments(prev => [
      ...prev,
      {
        id: Math.max(0, ...prev.map(p => p.id)) + 1,
        repaymentAmount: '',
        yearToApplyPayment: '',
      },
    ]);
  }, [setAnnualPayments, setShowResults]);

  const handleDeletePayment = useCallback((id) => {
    setShowResults(false);
    setAnnualPayments(prev => prev.filter(payment => payment.id !== id));
  }, [setAnnualPayments, setShowResults]);

  return {
    handlePaymentInputChange,
    handleAddPayment,
    handleDeletePayment,
  };
};
